export const calculateStylesForCoverPhoto = facesBox => {
  if (!facesBox || facesBox.length < 4) return {};

  const [x, y, width, height] = facesBox;

  return {
    objectFit: 'cover',
    objectPosition: `${(x + width / 2) * 100}% ${(y + height / 2) * 100}%`,
  };
};
